import Vue from "vue";

import VsSelect from "./VsSelect";
import VsSwitch from "./VsSwitch";
// import VsCheckbox from "./VsCheckbox";
import Datepicker from 'vuejs-datepicker';
import DatepickerHOC from './Datepicker';

Vue.component('VsSelect', VsSelect(Vue.component('VsSelect')));
Vue.component('VsSwitch', VsSwitch(Vue.component('VsSwitch')));
// Vue.component('VsCheckbox', VsCheckbox(Vue.component('VsCheckbox')));
Vue.component('datepicker', DatepickerHOC(Datepicker));
